/* eslint-disable no-self-assign */
import { Component, Vue } from 'vue-property-decorator'
import * as echarts from 'echarts';
import { getMarketClueStatisticalData } from '@/api/common'
import {Loading} from "element-ui";

@Component({})
export default class StatisticsData extends Vue {
    // 变量
    dataFilter = 0
    marketClueBackoffSum = 0 // 回退量
    marketClueIsSignSum = 0 // 签约量
    marketClueReceiverSum = 0 // 下发量
    marketClueSum = 0 // 总量
    marketClueIsSignPriceSum = 0 // 总签约金额

    // ------ 生命周期 ------
    created() {
        // console.log(111);
    }
    mounted() {
        this.getData()
    }

    // ------ 方法 ------
    changeRadio() {
        this.getData()
    }
    async getData() {
        const loading = Loading.service({
            text: '正在加载，请稍后'
        })
        const { marketClueUserSum, marketClueBackoffSum, marketClueIsSignSum, marketClueReceiverSum, marketClueSum,customerConversionBackGroupByTypes, isSignTrend, marketClueIsSignPriceSum }: any = await getMarketClueStatisticalData({ timeType: this.dataFilter })
        this.marketClueBackoffSum = marketClueBackoffSum
        this.marketClueIsSignSum = marketClueIsSignSum
        this.marketClueReceiverSum = marketClueReceiverSum
        this.marketClueSum = marketClueSum
        this.marketClueIsSignPriceSum = marketClueIsSignPriceSum
        this.createEfficiencyCharts(marketClueUserSum)
        this.createProportionEacharts({ marketClueSum, marketClueReceiverSum, marketClueIsSignSum })
        this.createTrendCharts(isSignTrend)
        this.createBackoffCharts(customerConversionBackGroupByTypes)
        loading.close()
    }
    // 签约比例
    createProportionEacharts({ marketClueSum, marketClueReceiverSum, marketClueIsSignSum }) {
        const chartDom = document.getElementById('proportion-sum');
        const myChart = echarts.init(chartDom);
        const option = {
            series: [
                {
                    name: '',
                    type: 'pie',
                    radius: '50%',
                    data: [
                        { value: marketClueSum, name: '总量' }
                    ],
                    itemStyle: {
                        normal: {
                            color: function (params) {
                                return 'rgba(255, 225, 225, 1)'
                            }
                        }
                    },
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    },
                    label: {
                        position: 'inner',
                        formatter(params) {
                            let str = ''
                            str = '总量： 100%'
                            return str
                        }
                    },
                    labelLayout(params) {
                        return {
                            x: 300,
                            y: 30,
                            verticalAlign: 'middle',
                            align: 'right',
                        }
                    }
                }
            ]
        };
        option && myChart.setOption(option);

        const chartDom1 = document.getElementById('proportion-issue');
        const myChart1 = echarts.init(chartDom1);
        const option1 = {
            series: [
                {
                    name: '',
                    type: 'pie',
                    radius: '55%',
                    minAngle: 3,
                    data: [
                        { value: marketClueSum - marketClueReceiverSum || 1, name: '总量' },
                        { value: marketClueReceiverSum, name: '下发量' }
                    ],
                    itemStyle: {
                        normal: {
                            color: function (params) {
                                return params.name === '总量' ? 'rgba(255,255,255,0)' : 'rgba(255, 185, 185, 1)'
                            }
                        }
                    },
                    emphasis: {
                        scale: false,
                        scaleSize: 0,
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0)',
                        }
                    },
                    label: {
                        position: 'inner',
                        formatter(params) {
                            let str = ''
                            // str = params.data.name == '总量' ? '' :  params.data.name + ': ' + Math.floor(params.data.value/marketClueSum * 100) + '%'
                            if(params.data.name != '总量') {
                                str = params.data.name + ': '
                                str += params.data.value > 0 ? Math.floor(params.data.value/marketClueSum * 100) + '%' : '0%'
                            }
                            return str
                        }
                    },
                    labelLayout(params) {
                        return {
                            x: 100,
                            y: 300,
                            verticalAlign: 'middle',
                            align: 'left',
                            text: 'asdasdasdasdasdasd '
                        }
                    }
                }
            ]
        };
        option1 && myChart1.setOption(option1);

        const chartDom3 = document.getElementById('proportion-sign');
        const myChart3 = echarts.init(chartDom3);
        const option3 = {

            series: [
                {
                    name: '',
                    type: 'pie',
                    radius: '60%',
                    startAngle: 100,
                    minAngle: 3,
                    data: [
                        { value: marketClueSum - marketClueIsSignSum || 1, name: '总量' },
                        { value: marketClueIsSignSum, name: '签约量' }
                    ],
                    itemStyle: {
                        normal: {
                            color: function (params) {
                                return params.name === '总量' ? 'rgba(255,255,255,0)' : 'rgba(255, 143, 143, 1)'
                            }
                        }
                    },
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 0,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0)',
                        }
                    },
                    label: {
                        position: 'inner',
                        formatter(params) {
                            let str = ''
                            str = params.data.name == '总量' ? '' : params.data.value == 0 || !params.data.value ? '签约量: 0%' :  params.data.name + ': ' + Math.floor(params.data.value/marketClueSum * 100) + '%'
                            return str
                        }
                    },
                    labelLayout(params) {
                        return {
                            x: 60,
                            y: 40,
                            verticalAlign: 'middle',
                            align: 'left',
                        }
                    }
                }
            ]
        };
        option3 && myChart3.setOption(option3);


    }
    // 签约趋势
    createTrendCharts(array) {
        const TimeList: string[] = []
        const marketClueCounts = []
        const marketClueReceiverCounts = []
        const financeOrderCounts = []
        // const currMonth = new Date().getMonth() + 1

        // switch(this.dataFilter) {
        //     case 0:
        //         TimeList = ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
        //         break;
        //     case 1:
        //         TimeList = [ '第一周', '第二周', '第三周', '第四周' ]
        //         break;
        //     case 2:
        //         TimeList = getCurrQuarterInMonth()
        //         break;
        //     case 3:
        //         TimeList = [ '第一季度', '第二季度', '第三季度', '第四季度' ]
        // }


        // const data = new Array(10).fill(0)

        array.forEach(item => {
            TimeList.push(item.types)
            marketClueCounts.push(item.marketClueCount)
            marketClueReceiverCounts.push(item.marketClueReceiverCount)
            financeOrderCounts.push(item.financeOrderCount)
        })


        const chartDom = document.getElementById('trend') as HTMLElement
        const myChart = echarts.init(chartDom);
        const option = {
            title: {
                text: '',
                subtext: '签约趋势'
            },
            color: [ '#FF3030', '#57FF39', '#8920FF' ],
            tooltip: {
                trigger: 'axis'
            },
            legend: {
                data: ['总线索', '下发量', '签约量'],
                right: 20
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: {
                type: 'category',
                boundaryGap: false,
                data: TimeList
            },
            yAxis: {
                type: 'value'
            },
            series: [
                {
                    name: '总线索',
                    type: 'line',
                    data: marketClueCounts
                },
                {
                    name: '下发量',
                    type: 'line',
                    data: marketClueReceiverCounts
                },
                {
                    name: '签约量',
                    type: 'line',
                    data: financeOrderCounts
                },
            ]
        }
        myChart.setOption(option);
    }
    // 员工效能
    createEfficiencyCharts(data: any[]) {
        const arr = []
        data.forEach((item: any) => {
            const obj = {
                product: item.marketClueUserRealName,
                '总线索量': item.marketClueUserSum,
                '下发量': item.marketClueUserReceiverSum,
                '签约量': item.marketClueUserIsSignSum
            }
            arr.push(obj)
        })
        const chartDom = document.getElementById('efficiency') as HTMLElement
        const myChart: any = echarts.init(chartDom);
        const option = {
            title: {
                subtext: '员工效能'
            },
            legend: [
                {
                    itemStyle: {
                        color: 'inherit'
                    },
                    right: 10
                },
            ],
            tooltip: {},
            dataset: {
                dimensions: ['product', '总线索量', '下发量', '签约量'],
                source: arr
            },
            xAxis: {
                type: 'category',
                name: '员工姓名'
            },
            yAxis: {

            },
            series: [
                { type: 'bar', barMinHeight: 3, itemStyle: { color: '#E16A6A', opacity: 0.7 }, label: { show: true, position: 'top' } },
                { type: 'bar', barMinHeight: 3, itemStyle: { color: '#F7E375', opacity: 0.7 }, label: { show: true, position: 'top' } },
                { type: 'bar', barMinHeight: 3, itemStyle: { color: '#7AFF8F', opacity: 0.7 }, label: { show: true, position: 'top' } },
            ]
        }
        myChart.setOption(option);
    }
    // 回退原因占比
    createBackoffCharts(array) {
        let data = []
        // if(array.length > 0) {
            data = array.map(item => ({ name: item.types, value: item.count }))
            const chartDom = document.getElementById('back-off') as HTMLElement
            const myChart = echarts.init(chartDom);
            const option = {
                title: {
                    text: '',
                    subtext: '回退原因占比',
                    left: 'left'
                },
                color: [ '#FFE1E1', '#ACFAA1', '#FFEE28', '#FF8F8F', '#6583F9' ],
                tooltip: {
                    trigger: 'item'
                },
                series: [
                    {
                        name: '',
                        type: 'pie',
                        radius: '50%',
                        stillShowZeroSum: false,
                        hoverAnimation:false,
                        data: data,
                        label: {
                            formatter: '{b}: {d}%',
                            width: 100,
                            overflow: "breakAll"
                        },
                    }
                ]
            };
            // myChart.on('mouseover', (params) => {
            //     console.log(params);
            // })
            myChart.setOption(option);
        // }
    }
}
